module.exports = __webpack_public_path__ + "img/meh.000bedcd.svg";